import { css } from '@linaria/core';

export const StyledSuggestedText = css`
	background: var(--color-black-m);
	/* one time custom border radius */
	/* stylelint-disable */
	border-bottom-right-radius: 2px !important;
	/* stylelint-enable */
`;
